export default __webpack_public_path__ + "static/media/08c51ccdb895b78be30e9b884f85f10.33d3128f.png";